import React from 'react'

import AlertModal from '../../../components/messenger/AlertModal'
import AssetModal from '../../../modules/assets/show/AssetsModal'
import AvailabilityDetailsModal from '../../../modules/availability/show/AvailabilityDetailsModal'
import ChangeAvailabilityStatusModal from '../../../modules/availability/changeStatus/ChangeAvailabilityStatusModal'
import EditAvailabilityStatusSourceConfigModal from '../../../modules/availability/statusSource/EditAvailabilityStatusSourceConfigModal'
import BucketsModal from '../../../modules/buckets/list/BucketsModal'
import ChangePasswordModal from '../../../modules/users/changePassword/ChangePasswordModal'
import ChecklistModal from '../../../modules/checklists/show/ChecklistModal'
import ChecklistPreviewModal from '../../../modules/checklists/preview/ChecklistPreviewModal'
import ChecklistTemplatesModal from '../../../modules/checklists/templates/ChecklistTemplatesModal'
import CloneChecklistModal from '../../../modules/checklists/clone/CloneChecklistModal'
import CloneServiceOrderModal from '../../../modules/serviceOrders/clone/CloneServiceOrderModal'
import CreateStrongPasswordModal from '../../../modules/session/createStrongPassword/CreateStrongPasswordModal'
import CreateTemplateRecordModal from '../../../modules/templateRecords/create/CreateTemplateRecordModal'
import DuplicatedServiceOrdersModal from '../../../modules/serviceOrders/duplicates/DuplicatedServiceOrdersModal'
import EditActionPlanModal from '../../../modules/actionPlans/edit/EditActionPlanModal'
import EditAssetModal from '../../../modules/assets/edit/EditAssetModal'
import EditAssetsModal from '../../../modules/assets/bulkEdit/EditAssetsModal'
import EditBucketModal from '../../../modules/buckets/edit/EditBucketModal'
import EditFieldsModal from '../../../modules/fields/edit/EditFieldsModal'
import EditFormModal from '../../../modules/forms/editV2/EditFormModal'
import EditFormsModal from '../../../modules/forms/bulkEdit/EditFormModal'
import EditGroupModal from '../../../modules/groups/edit/EditGroupModal'
import EditIntegrationModal from '../../../modules/integrations/edit/EditIntegrationModal'
import EditIntegrationTokenModal from '../../../modules/integrations/editTokens/EditIntegrationTokenModal'
import EditLinkTreeItemsModal from '../../../modules/linkTreeItems/edit/EditLinkTreeItemsModal'
import EditLinkTreeModal from '../../../modules/linkTrees/edit/EditLinkTreeModal'
import EditMinicrudModal from '../../../modules/minicruds/edit/EditMinicrudModal'
import EditPermissionsModal from '../../../modules/settings/editV2/EditPermissionsModal'
import EditPlaceLevelModal from '../../../modules/placeLevels/edit/EditPlaceLevelModal'
import EditPlaceModal from '../../../modules/places/editV2/EditPlaceModal'
import EditPlaceTypesModal from '../../../modules/placeTypes/edit/EditPlaceTypeModal'
import EditProfileModal from '../../../modules/profiles/edit/EditProfileModal'
import EditProjectModal from '../../../modules/projects/edit/EditProjectModal'
import EditPublicTokenModal from '../../../modules/publicTokens/edit/EditPublicTokenModal'
import EditScreenKanbanColumnModal from '../../../modules/screens/editKanbanColumn/EditScreenKanbanColumnModal'
import EditScreenModal from '../../../modules/screens/edit/EditScreenModal'
import EditScreenViewModal from '../../../modules/screenViews/edit/EditScreenViewModal'
import EditSemaphoreConfigModal from '../../../modules/configs/editSemaphore/EditSemaphoreConfigModal'
import ListServiceOrderAutomaticDistributionConfigModal from '../../../modules/configs/serviceOrderAutomaticDistribution/list/ListServiceOrderAutomaticDestributionConfigModal'
import EditServiceOrderModal from '../../../modules/serviceOrders/editV2/EditServiceOrderModal'
import EditServiceOrdersModal from '../../../modules/serviceOrders/bulkEdit/EditServiceOrdersModal'
import EditServiceOrdersStatusModal from '../../../modules/serviceOrders/editStatus/EditServiceOrdersStatusModal'
import EditServiceOrdersUserModal from '../../../modules/serviceOrders/editUser/EditServiceOrdersUserModal'
import EditTagModal from '../../../modules/tags/edit/EditTagModal'
import EditTemplateModal from '../../../modules/templates/edit/EditTemplateModal'
import EditTriggerModal from '../../../modules/triggers/editV2/EditTriggerModal'
import EditUserModal from '../../../modules/users/editV2/EditUserModal'
import EditUsersModal from '../../../modules/users/bulkEdit/EditUsersModal'
import EditWidgetModal from '../../../modules/screens/editWidget/EditWidgetModal'
import ExecuteServiceOrderModal from '../../../modules/serviceOrders/executionV2/ExecuteServiceOrderModal'
import ExportHistoryModal from '../../../modules/importsExports/exportHistory/ExportHistoryModal'
import ExportModal from '../../../modules/importsExports/export/ExportModal'
import FormReplyModal from '../../../modules/formReplies/show/FormReplyModal'
import FormReplyServiceOrdersModal from '../../../modules/formReplies/listServiceOrders/FormReplyServiceOrdersModal'
import FormSendsModal from '../../../modules/forms/formSends/FormSendsModal'
import ImportHistoryModal from '../../../modules/importsExports/importHistory/ImportHistoryModal'
import LevelsSettingsModal from '../../../modules/places/levelsSettings/LevelsSettingsModal'
import LinkTreeListModal from '../../../modules/linkTrees/list/LinkTreeListModal'
import LogModal from '../../../modules/logs/show/LogModal'
import MailPublicExecutionModal from '../../../modules/serviceOrders/mailPublicExecution/MailPublicExecutionModal'
import NonComplianceModal from '../../../modules/nonComplianceV2/show/NonComplianceModal'
import PlaceModal from '../../../modules/places/show/PlaceModal'
import ProjectTemplatesModal from '../../../modules/projects/templates/ProjectTemplatesModal'
import PublicTokenModal from '../../../modules/publicTokens/show/PublicTokenModal'
import PublicTokensModal from '../../../modules/publicTokens/list/PublicTokensModal'
import RemoveServiceOrderModal from '../../../modules/serviceOrders/remove/RemoveServiceOrderModal'
import RepliesModal from '../../../modules/replies/list/RepliesModal'
import SegmentModal from '../../../modules/segments/show/SegmentModal'
import EditSegmentsModal from '../../../modules/segments/bulkEdit/EditSegmentsModal'
import SelectIntegrationModal from '../../../modules/integrations/select/SelectIntegrationModal'
import SelectIntegrationServiceModal from '../../../modules/integrations/selectIntegrationService/SelectIntegrationServiceModal'
import SelectWidgetTypeModal from '../../../modules/screens/selectWidgetType/SelectWidgetTypeModal'
import ServiceOrderModal from '../../../modules/serviceOrders/show/ServiceOrderModal'
import ServiceOrderResumeModal from '../../../modules/serviceOrders/resumeV2/ServiceOrderResumeModal'
import TagsModal from '../../../modules/tags/list/TagsModal'
import TemplateModal from '../../../modules/templates/show/TemplateModal'
import TemplateRecordsModal from '../../../modules/templateRecords/list/TemplateRecordsModal'
import TemplatesModal from '../../../modules/templates/list/TemplatesModal'
import TemplatesSugestionsModal from '../../../modules/triggers/templates/TemplatesSugestionsModal'
import TriggerCallModal from '../../../modules/triggerCalls/show/TriggerCallModal'
import TriggersModal from '../../../modules/triggers/list/TriggersModal'
import UserModal from '../../../modules/users/show/UserModal'
import ContractModal from '../../../modules/contracts/show/ContractModal'
import NonComplianceBulkEditModal from '../../../modules/nonComplianceV2/bulkEdit/NonComplianceBulkEditModal'
import RoutinesModal from '../../../modules/routines/list/RoutinesModal'
import EditRoutineModal from '../../../modules/routines/edit/EditRoutineModal'
import EditMaskModal from '../../../modules/mask/edit/EditMaskModal'
import TypeFormModal from '../../../containers/typeform/TypeFormModal'
import EditWebHookModal from '../../../modules/webhook/edit/EditWebhookModal'
import EditStaysWebhookModal from '../../../modules/webhook/plugins/stays/edit/EditStaysWebhookModal'
import WebhookModal from '../../../modules/webhook/show/WebhookModal'
import EditDynamicServiceOrdersModal from '../../../modules/dynamicServiceOrders/editV2/EditDynamicServiceOrdersModal'
import EditPlacesModal from '../../../modules/places/bulkEdit/EditPlacesModal'
import ExportSelectedServiceOrdersModal from '../../../modules/serviceOrders/export/ExportSelectedServiceOrdersModal'
import GenerateActivatedQRCodesModal from '../../../modules/qrcodes/generateActivated/GenerateActivatedQRCodesModal'
import EditServiceOrderAutomaticDistributionConfigModal from '../../../modules/configs/serviceOrderAutomaticDistribution/edit/EditServiceOrderAutomaticDistributionConfigModal'
import MapGroupedDetail from '../../../components/map/groupedDetails/MapGroupedDetail'
import EditSlaConfigModal from '../../../modules/configs/serviceOrderSla/edit/EditSlaConfigModal'
import ListServiceOrderSlaConfigModal from '../../../modules/configs/serviceOrderSla/list/ListServiceOrderConfigSlaModal'

import EditStockItemModal from '../../../modules/stocks/edit/EditStocksModal'
import StockItemDetailModal from '../../../modules/stocks/show/StockItemDetailModal'
import TransferStockItemsModal from '../../../modules/stocks/bulkTransfer/TransferStockItemsModal'
import TransfersHistoryModal from '../../../modules/stocks/transferHistory/TransfersHistoryModal'

import AddSegwareTechnicianModal from '../../../modules/integrations/_services/segware/AddSegwareTechnicianModal'
import ListSegwareTechnicianAssociatedModal from '../../../modules/integrations/_services/segware/ListSegwareTechnicianAssociatedModal'
import EditProcessesModal from '../../../modules/processes/edit/EditProcessesModal'

const ModalsRoutes = () => (
  <>
    <AssetModal name="asset/show" />
    <EditAssetModal name="asset/edit" />
    <EditAssetsModal name="asset/bulkEdit" />
    <EditMaskModal name="masks/edit" />
    <ServiceOrderModal name="serviceOrders/show" />
    <CloneServiceOrderModal name="serviceOrders/clone" />
    <RemoveServiceOrderModal name="serviceOrders/remove" />
    <EditServiceOrdersUserModal name="serviceOrders/editUser" />
    <EditServiceOrdersStatusModal name="serviceOrders/editStatus" />
    <ExportSelectedServiceOrdersModal name="serviceOrders/export" />
    <EditServiceOrderModal name="serviceOrders/edit" />
    <EditServiceOrdersModal name="serviceOrders/bulkEdit" />
    <ExecuteServiceOrderModal name="serviceOrders/execution" />
    <ServiceOrderResumeModal name="serviceOrders/resume" />
    <DuplicatedServiceOrdersModal name="serviceOrders/duplicates" />
    <UserModal name="users/show" />
    <ContractModal name="contracts/show" />
    <EditUserModal name="users/edit" />
    <ChangePasswordModal name="users/changePassword" />
    <EditUsersModal name="users/bulkEdit" />
    <ChecklistModal name="checklists/show" />
    <ChecklistPreviewModal name="checklists/preview" />
    <ChecklistTemplatesModal name="checklists/templates" />
    <CloneChecklistModal name="checklists/clone" />
    <RepliesModal name="replies/list" />
    <EditDynamicServiceOrdersModal name="dynamicServiceOrders/edit" />
    <EditStockItemModal name="stockItem/edit" />
    <StockItemDetailModal name="stockItem/show" />
    <TransferStockItemsModal name="stockItems/bulkTransfers" />
    <TransfersHistoryModal name="stockItem/transfersHistory" />
    <PlaceModal name="places/show" />
    <AvailabilityDetailsModal name="availability/show" />
    <ChangeAvailabilityStatusModal name="availability/changeStatus" />
    <EditAvailabilityStatusSourceConfigModal name="availability/statusSourceConfig" />
    <EditPlaceModal name="places/edit" />
    <EditPlacesModal name="places/bulkEdit" />
    <LevelsSettingsModal name="places/levelSettings" />
    <EditLinkTreeItemsModal name="linkTreeItems/edit" />
    <LinkTreeListModal name="linkTrees/list" />
    <EditLinkTreeModal name="linkTrees/edit" />
    <MailPublicExecutionModal name="serviceOrders/mailPublicExecution" />
    <EditFormModal name="forms/edit" />
    <EditFormsModal name="forms/bulkEdit" />
    <FormReplyModal name="formReplies/show" />
    <FormReplyServiceOrdersModal name="formReplies/serviceOrders" />
    <CreateTemplateRecordModal name="templateRecords/create" />
    <TemplateRecordsModal name="templateRecords/list" />
    <TemplatesModal name="templates/list" />
    <TagsModal name="tags/list" />
    <TemplateModal name="templates/show" />
    <EditTemplateModal name="templates/edit" />
    <NonComplianceModal name="nonCompliancesV2/show" />
    <NonComplianceBulkEditModal name="nonCompliancesV2/bulkEdit" />
    <ExportModal name="exports/new" />
    <ExportHistoryModal name="exports/history" />
    <ImportHistoryModal name="imports/history" />
    <FormSendsModal name="formInvites/list" />
    <PublicTokensModal name="publicTokens/list" />
    <PublicTokenModal name="publicTokens/show" />
    <EditPublicTokenModal name="publicTokens/edit" />
    <BucketsModal name="buckets/list" />
    <EditBucketModal name="buckets/edit" />
    <TriggersModal name="triggers/list" />
    <EditTriggerModal name="triggers/edit" />
    <TemplatesSugestionsModal name="triggers/templates" />
    <LogModal name="logs/show" />
    <SegmentModal name="segments/show" />
    <EditSegmentsModal name="segments/bulkEdit" />
    <EditActionPlanModal name="actionPlans/edit" />
    <EditScreenViewModal name="screenViews/edit" />
    <EditFieldsModal name="fields/edit" />
    <EditPermissionsModal name="permissions/edit" />
    <EditProfileModal name="profiles/edit" />
    <TriggerCallModal name="triggerCalls/show" />
    <EditScreenModal name="screens/edit" />
    <EditProcessesModal name="processes/edit" />
    <EditScreenKanbanColumnModal name="screens/kanbanColumn/edit" />
    <EditWidgetModal name="screens/widget/edit" />
    <SelectWidgetTypeModal name="screens/widget/selectType" />
    <AlertModal name="alert" />
    <EditGroupModal name="groups/edit" />
    <EditMinicrudModal name="minicruds/edit" />
    <EditPlaceLevelModal name="placeLevels/edit" />
    <EditTagModal name="tags/edit" />
    <EditPlaceTypesModal name="placeTypes/edit" />
    <EditProjectModal name="project/edit" />
    <ProjectTemplatesModal name="projects/templates" />
    <CreateStrongPasswordModal name="password/new" />
    <EditIntegrationModal name="integrations/edit" />
    <EditWebHookModal name="webhook/edit" />
    <EditStaysWebhookModal name="webhook/edit/stays" />
    <WebhookModal name="webhook/show" />
    <SelectIntegrationServiceModal name="integrations/selectService" />
    <SelectIntegrationModal name="integrations/select" />
    <EditIntegrationTokenModal name="integrations/new/token" />
    <EditSemaphoreConfigModal name="configs/editSemaphore" />
    <ListServiceOrderAutomaticDistributionConfigModal name="serviceOrderAutomaticDistribution/list" />
    <EditServiceOrderAutomaticDistributionConfigModal name="serviceOrderAutomaticDistribution/edit" />
    <RoutinesModal name="routines/list" />
    <EditRoutineModal name="routines/edit" />
    <TypeFormModal name="typeform" />
    <GenerateActivatedQRCodesModal name="qrcodes" />
    <AddSegwareTechnicianModal name="integrations/addSegwareTechnician" />
    <ListSegwareTechnicianAssociatedModal name="integrations/listSegwareTechnicianAssociated" />
    <EditSlaConfigModal name="configs/editSla" />
    <ListServiceOrderSlaConfigModal name="configs/listSla" />
    <MapGroupedDetail name="map/groupedDetail" />
  </>
)

export default ModalsRoutes
